/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountInstanceFull,
  DiscountInstanceFullOptional,
  DiscountInstanceFullMetaI,
  DiscountInstanceFullTrackedI,
} from "./discount-instance-full";
import {
  DiscountInstanceFullTracked,
  DiscountInstanceFullMeta,
} from "./discount-instance-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";

/**
 *
 * @export
 * @interface CatalogDiscountInstancePublicDTO
 */
export interface CatalogDiscountInstancePublicDTOOptional extends DiscountInstanceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  instanceId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  endActive?: Date;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  autoApply?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isSpecial?: boolean;
}

export interface CatalogDiscountInstancePublicDTO
  extends CatalogDiscountInstancePublicDTOOptional, DiscountInstanceFull {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  instanceId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  endActive?: Date;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  autoApply?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isGlobal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isSpecial?: boolean;
}

export interface CatalogDiscountInstancePublicDTOTrackedI extends DiscountInstanceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  percent?: string;
  percentIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  autoApply?: boolean;
  autoApplyIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isGlobal?: boolean;
  isGlobalIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogDiscountInstancePublicDTO
   */
  isSpecial?: boolean;
  isSpecialIsSet: boolean;
}

transformDatesMap.set(
  "CatalogDiscountInstancePublicDTO",
  function (model: CatalogDiscountInstancePublicDTO) {
    if (typeof model.startActive == "string")
      model.startActive = new Date(model.startActive);
    if (typeof model.endActive == "string")
      model.endActive = new Date(model.endActive);
  },
);

export type CatalogDiscountInstancePublicDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  percent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  autoApply: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isGlobal: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isSpecial: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var CatalogDiscountInstancePublicDTOMeta: CatalogDiscountInstancePublicDTOMetaI =
  {} as CatalogDiscountInstancePublicDTOMetaI;
CatalogDiscountInstancePublicDTOMeta = typeMeta(
  "CatalogDiscountInstancePublicDTO",
  {
    isDeleted: propertyMeta(
      "isDeleted",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
    isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
    tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
    instanceId: propertyMeta(
      "instanceId",
      false,
      true,
      true,
      MetaTypesBase.number,
    ),
    startActive: propertyMeta(
      "startActive",
      false,
      false,
      false,
      MetaTypesBase.Date,
    ),
    endActive: propertyMeta(
      "endActive",
      false,
      false,
      false,
      MetaTypesBase.Date,
    ),
    discountType: propertyMeta(
      "discountType",
      false,
      false,
      false,
      DiscountTypeMeta,
    ),
    amountCents: propertyMeta(
      "amountCents",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    percent: propertyMeta("percent", false, false, false, MetaTypesBase.string),
    autoApply: propertyMeta(
      "autoApply",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
    isGlobal: propertyMeta(
      "isGlobal",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
    isSpecial: propertyMeta(
      "isSpecial",
      false,
      false,
      false,
      MetaTypesBase.boolean,
    ),
  },
);

const metaI = CatalogDiscountInstancePublicDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DiscountInstanceFullMeta]);
  metaI.isDeleted.inheritedFrom = DiscountInstanceFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = DiscountInstanceFullMeta.isNew;
  metaI.tempID.inheritedFrom = DiscountInstanceFullMeta.tempID;
  metaI.instanceId.inheritedFrom = DiscountInstanceFullMeta.instanceId;
  metaI.startActive.inheritedFrom = DiscountInstanceFullMeta.startActive;
  metaI.endActive.inheritedFrom = DiscountInstanceFullMeta.endActive;
  metaI.discountType.inheritedFrom = DiscountInstanceFullMeta.discountType;
  metaI.amountCents.inheritedFrom = DiscountInstanceFullMeta.amountCents;
  metaI.percent.inheritedFrom = DiscountInstanceFullMeta.percent;
  metaI.autoApply.inheritedFrom = DiscountInstanceFullMeta.autoApply;
  metaI.isGlobal.inheritedFrom = DiscountInstanceFullMeta.isGlobal;
  metaI.isSpecial.inheritedFrom = DiscountInstanceFullMeta.isSpecial;
});

export class CatalogDiscountInstancePublicDTOTracked
  extends DiscountInstanceFullTracked
  implements CatalogDiscountInstancePublicDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  instanceId__I?: number = undefined;

  get instanceIdIsSet() {
    return this.instanceId !== undefined;
  }
  set instanceIdIsSet(v: boolean) {}
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  percent__I?: string = undefined;
  percentIsSet: boolean = false;
  set percent(v: undefined | string) {
    if (v !== undefined) {
      this.percent__I = v;
      this.percentIsSet = true;
    } else {
      this.percent__I = v || undefined;
      this.percentIsSet = false;
    }
    this.changeTracker = true;
  }
  get percent() {
    return this.percent__I;
  }
  autoApply__I?: boolean = undefined;
  autoApplyIsSet: boolean = false;
  set autoApply(v: undefined | boolean) {
    if (v !== undefined) {
      this.autoApply__I = v;
      this.autoApplyIsSet = true;
    } else {
      this.autoApply__I = v || undefined;
      this.autoApplyIsSet = false;
    }
    this.changeTracker = true;
  }
  get autoApply() {
    return this.autoApply__I;
  }
  isGlobal__I?: boolean = undefined;
  isGlobalIsSet: boolean = false;
  set isGlobal(v: undefined | boolean) {
    if (v !== undefined) {
      this.isGlobal__I = v;
      this.isGlobalIsSet = true;
    } else {
      this.isGlobal__I = v || undefined;
      this.isGlobalIsSet = false;
    }
    this.changeTracker = true;
  }
  get isGlobal() {
    return this.isGlobal__I;
  }
  isSpecial__I?: boolean = undefined;
  isSpecialIsSet: boolean = false;
  set isSpecial(v: undefined | boolean) {
    if (v !== undefined) {
      this.isSpecial__I = v;
      this.isSpecialIsSet = true;
    } else {
      this.isSpecial__I = v || undefined;
      this.isSpecialIsSet = false;
    }
    this.changeTracker = true;
  }
  get isSpecial() {
    return this.isSpecial__I;
  }
  constructor(
    config?: CatalogDiscountInstancePublicDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;
    if (this.instanceIdIsSet == true && other?.instanceIdIsSet == true)
      return this.instanceId == other.instanceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.instanceId) {
      this.instanceIdIsSet = true;
    }
  }
  assignFrom(
    config: CatalogDiscountInstancePublicDTOOptional,
    options?: AssignOptions,
  ): CatalogDiscountInstancePublicDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (config.percent && this.percentApplyFilter(optionsRequired.filter)) {
      this.percent = config.percent;
      if (optionsRequired.unassign) this.percentIsSet = false;
      else this.percentIsSet = true;
    }
    if (config.autoApply && this.autoApplyApplyFilter(optionsRequired.filter)) {
      this.autoApply = config.autoApply;
      if (optionsRequired.unassign) this.autoApplyIsSet = false;
      else this.autoApplyIsSet = true;
    }
    if (config.isGlobal && this.isGlobalApplyFilter(optionsRequired.filter)) {
      this.isGlobal = config.isGlobal;
      if (optionsRequired.unassign) this.isGlobalIsSet = false;
      else this.isGlobalIsSet = true;
    }
    if (config.isSpecial && this.isSpecialApplyFilter(optionsRequired.filter)) {
      this.isSpecial = config.isSpecial;
      if (optionsRequired.unassign) this.isSpecialIsSet = false;
      else this.isSpecialIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(
    filter?: FilterVarsType,
  ): CatalogDiscountInstancePublicDTOTrackedI {
    const cloned = {} as CatalogDiscountInstancePublicDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.percentIsSetDeep() &&
      this.percentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.percentIsSet = true;
      cloned.percent = this.percent;
    } else {
      //cloned.percentIsSet = false
    }
    if (
      this.autoApplyIsSetDeep() &&
      this.autoApplyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.autoApplyIsSet = true;
      cloned.autoApply = this.autoApply;
    } else {
      //cloned.autoApplyIsSet = false
    }
    if (
      this.isGlobalIsSetDeep() &&
      this.isGlobalApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isGlobalIsSet = true;
      cloned.isGlobal = this.isGlobal;
    } else {
      //cloned.isGlobalIsSet = false
    }
    if (
      this.isSpecialIsSetDeep() &&
      this.isSpecialApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isSpecialIsSet = true;
      cloned.isSpecial = this.isSpecial;
    } else {
      //cloned.isSpecialIsSet = false
    }
    if (!isDeleted(this) && !this.instanceIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(
    filter?: FilterVarsType,
  ): CatalogDiscountInstancePublicDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.percentApplyFilter(filter)) this.percentIsSet = false;

    if (!this.autoApplyApplyFilter(filter)) this.autoApplyIsSet = false;

    if (!this.isGlobalApplyFilter(filter)) this.isGlobalIsSet = false;

    if (!this.isSpecialApplyFilter(filter)) this.isSpecialIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.isDeleted,
      CatalogDiscountInstancePublicDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.isNew,
      CatalogDiscountInstancePublicDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.tempID,
      CatalogDiscountInstancePublicDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.instanceId,
      CatalogDiscountInstancePublicDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.startActive,
      CatalogDiscountInstancePublicDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.endActive,
      CatalogDiscountInstancePublicDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.discountType,
      CatalogDiscountInstancePublicDTOMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.amountCents,
      CatalogDiscountInstancePublicDTOMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  percentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.percent,
      CatalogDiscountInstancePublicDTOMeta,
      this.percent,
      this,
    );
  }
  percentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.percentIsSet && this.percentApplyFilter(filter)) return true;

    return false;
  }
  autoApplyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.autoApply,
      CatalogDiscountInstancePublicDTOMeta,
      this.autoApply,
      this,
    );
  }
  autoApplyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.autoApplyIsSet && this.autoApplyApplyFilter(filter)) return true;

    return false;
  }
  isGlobalApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.isGlobal,
      CatalogDiscountInstancePublicDTOMeta,
      this.isGlobal,
      this,
    );
  }
  isGlobalIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isGlobalIsSet && this.isGlobalApplyFilter(filter)) return true;

    return false;
  }
  isSpecialApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogDiscountInstancePublicDTOMeta.isSpecial,
      CatalogDiscountInstancePublicDTOMeta,
      this.isSpecial,
      this,
    );
  }
  isSpecialIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isSpecialIsSet && this.isSpecialApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.percentIsSetDeep(filter)) return true;
    if (this.autoApplyIsSetDeep(filter)) return true;
    if (this.isGlobalIsSetDeep(filter)) return true;
    if (this.isSpecialIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
